define('bizzabo/models/Persons',[
    'bizzabo/bzapi',
    'bizzabo/models/SyncedCollection',
    'bizzabo/models/Person'
], function(
    BZAPI,
    SyncedCollection,
    Person
    ) {

    var Persons = SyncedCollection.extend({

        model : Person,
        isSynced : false,

        comparator : function(person) {
            return person.get('first-name');
        },

        sync : function(method, model, options) {
            if (method == 'read') {
                BZAPI.getRsvpList(this.eventId, function(data) {
                    model.isSynced = true;
                    options.success && options.success(data.person, options);
                }, options.error);
            }
        }

    });

    return Persons;

});
